let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7Txts")).then(() => parcelRequire('1Wzy0'));